import { Vector3 } from "three/src/math/Vector3";
/**
 * Convert an Array to a Math.Vector3
 *
 * @param {Array|Vector3} arrayOrVector3 Input array or Vector3
 * @return {Vector3}
 */
function convertToVector3(arrayOrVector3) {
  if (arrayOrVector3 instanceof Vector3) {
    return arrayOrVector3;
  }

  return new Vector3(arrayOrVector3[0], arrayOrVector3[1], arrayOrVector3[2]);
}

export { convertToVector3 };
